<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/MaintainReport/Drawback'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3">
                <div class="form-group ">
                  <label class="label">วันที่เบิก/คืน/รับเข้า(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateStart"
                      name="jobsDateStart"
                      ref="jobsDateStart"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">วันที่เบิก/คืน/รับเข้า(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateEnd"
                      name="jobsDateEnd"
                      ref="jobsDateEnd"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label>เลขที่ใบงาน :</label>
                  <input v-model="qiJobNumber" type="text" class="form-control" placeholder="เลขที่ใบงาน"/>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">ชื่ออะไหล่:</label>
                  <treeselect id="qiProductCode" v-model="qiProductCode" :multiple="true" :options="qiProductCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">เขต:</label>
                  <treeselect id="jobArea" v-model="jobArea" :multiple="true" :options="qiJobAreaOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">สถานะ:</label>
                  <treeselect id="jobStatus" v-model="jobStatus" :multiple="true" :options="qiJobStatusOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">ผู้ขอเบิก/คืน:</label>
                  <treeselect
                    v-model="qiUserId"
                    :multiple="true"
                    :load-options="LoadUsersIdOptions"
                    :async="true"
                    v-on:open="reLoadUsersIdOptions"
                    v-on:select="ClearAfterselect"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="true"
                    ref="qiUserId"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right" v-if="this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN'])">
                <button
                  class="btn btn-outline-primary"
                  @click="exportExcel"
                  type="button"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped table-bordered table-hover table-checkable"
                id="reportTable" style="width:100%"
              >
                <thead>
                  <tr>
                    <td class="text-center font-weight-bold">วันที่เบิก/คืน/รับเข้า<br>(ว/ด/ป)</td>
                    <td class="text-center font-weight-bold">Month</td>
                    <td class="text-center font-weight-bold">Year</td>
                    <td class="text-center font-weight-bold">เขต</td>
                    <td class="text-center font-weight-bold">สถานะ</td>
                    <td class="text-center font-weight-bold">รหัสสินค้า</td>
                    <td class="text-center font-weight-bold">ชื่อสินค้า</td>
                    <td class="text-center font-weight-bold">จำนวน</td>
                    <td class="text-center font-weight-bold">ราคา:ชิ้น</td>
                    <td class="text-center font-weight-bold">มูลค่ารวม</td>
                    <td class="text-center font-weight-bold">ผู้ขอเบิก/คืน</td>
                    <td class="text-center font-weight-bold">ผู้ให้เบิก/คืน/รับเข้า</td>
                    <td class="text-center font-weight-bold">หมายเหตุ</td>
                    <td class="text-center font-weight-bold">เลขที่ใบงาน</td>
                    <td class="text-center font-weight-bold">เลขที่ใบเบิกสินค้า(รับเข้าอะไหล่)</td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import select2 from "../../Shared/Select2";
import axios from "axios";
import Collapsible from "../../Shared/Collapsible";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
require("sweetalert2");

export default {
  components: {
    select2,
    Collapsible,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      qiProductCode: null,
      jobStatus: null,
      qiJobNumber: null,
      jobArea: [],
      qiUserId: [],
      qiProductCodeOptions: [],
      qiJobAreaOptions: [],
      qiJobStatusOptions: [],
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      this.jobsDateStart = moment().startOf('month');
      this.jobsDateEnd = moment();
      const startOfMonth = this.jobsDateStart.format('DD/MM/YYYY');
      const today = this.jobsDateEnd.format('DD/MM/YYYY');

      this.qiJobNumber = null;
      this.qiProductCode = null;
      this.jobArea = null;
      this.jobStatus = null;
      this.qiUserId = null;

      $(`#qiProductCode`).val("").trigger("change");
      $(`#jobArea`).val("").trigger("change");
      $(`#jobStatus`).val("").trigger("change");
      $(`#qiUserId`).val("").trigger("change");

      $(this.$refs.jobsDateStart).datepicker('update', startOfMonth);
      $(this.$refs.jobsDateEnd).datepicker('update', today);
      $(this.$refs.jobsDateStart).val(startOfMonth).trigger('change');
      $(this.$refs.jobsDateEnd).val(today).trigger('change');
      // this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#reportTable").DataTable();
      table.search();
      table.draw();
    },
    exportExcel: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/QIJobs/ExportDrawback",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          QIProductCode: self.qiProductCode,
          QIJobStatus: self.jobStatus,
          QIJobNumber: self.qiJobNumber,
          QIJobArea: self.jobArea,
          QIUserId: self.qiUserId,
        },
      })
      .then(function(response) {
        if (response.status == "200") {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire(
            "ไม่พบข้อมูล",
            "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา",
            "warning"
          );
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        KTApp.unblockPage();
      });
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    LoadreProductCodeOptions: function (e) {
      var self = this;
      var qiTypesArray = ['QiSpare'];
      axios
        .post("/Api/QIJobs/ProductOption", {
          page: 0,
          limit: 1000,
          optionWithCode: true,
          qiTypes: qiTypesArray
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.qiProductCodeOptions = [];
            data.forEach((element) => {
              self.qiProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadJobAreaOptions: function (e) {
      var self = this;
      self.qiJobAreaOptions = [];
      var data = [
        {
          id: "Plant",
          text: "ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด",
        },
        {
          id: "Agent",
          text: "ซ่อมในตัวแทนจำหน่าย",
        },
      ];
      data.forEach((element) => {
        self.qiJobAreaOptions.push({
          id: element.id,
          label: element.text,
        });
      });
    },
    LoadJobStatusOptions: function (e) {
      var self = this;
      self.qiJobStatusOptions = [];
      var data = [
        {
          id: "Out",
          text: "เบิก",
        },
        {
          id: "In",
          text: "คืน",
        },
        {
          id: "Recv",
          text: "รับเข้า",
        },
      ];
      data.forEach((element) => {
        self.qiJobStatusOptions.push({
          id: element.id,
          label: element.text,
        });
      });
    },
    reLoadUsersIdOptions: function(){
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions({ action, searchQuery, callback }){
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/QIJobs/User/Options",{ 
            page: 1,
            search: searchQuery,
            type: ["JOB_QI_TYPE_DRAWBACK"],
            all: true,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              var result = [];
              data.forEach((element) => {
                result.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, result);
          })
          .catch(function(error) {});
      }
    },
  },
  async mounted() {
    let self = this;
    self.LoadreProductCodeOptions();
    self.LoadJobAreaOptions();
    self.LoadJobStatusOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    const today = moment();
    const startOfMonth = moment().startOf('month');
    self.jobsDateStart = startOfMonth;
    self.jobsDateEnd = today;

    $(self.$refs.jobsDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    }).datepicker('setDate', startOfMonth.toDate());
    $(self.$refs.jobsDateStart).on("changeDate", function(e) {
      self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.jobsDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    }).datepicker('setDate', today.toDate());
    $(self.$refs.jobsDateEnd).on("changeDate", function(e) {
      self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#reportTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/QIJobs/SearchDrawback",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
              EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
              QIProductCode: self.qiProductCode,
              QIJobStatus: self.jobStatus,
              QIJobNumber: self.qiJobNumber,
              QIJobArea: self.jobArea,
              QIUserId: self.qiUserId,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [30, 50, 100],
        pageLength: 30,
        language: {lengthMenu: "Display _MENU_",},
        ordering: false,
        columns: [
          {
            data: "finishedDate",
            className: "text-center",
            render: function (data) {
              return data ? moment(data).format("DD/MM/YYYY") : "";
            },
          },
          {
            data: "finishedDate",
            className: "text-center",
            render: function (data) {
              return data ? moment(data).format("MM") : "-";
            },
          },
          {
            data: "finishedDate",
            className: "text-center",
            render: function (data) {
              return data ? moment(data).format("YYYY") : "-";
            },
          },
          {
            data: "qiAreaPlant",
            className: "text-center",
            render: function (data) {
              return data
                ? "ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด"
                : "ซ่อมในตัวแทนจำหน่าย";
            },
          },
          {
          data: "qiTypeCode",
            className: "text-center",
            render: function (data, type, row) {
              if (data === "JOB_QI_TYPE_PRODUCT_RECEIVE") {
                return "รับเข้า";
              } else if (row.qiSubType === 1) {
                return "เบิก";
              } else if (row.qiSubType === 2) {
                return "คืน";
              }
              return "-";
            },
          },
          {
            data: "materialCode",
            className: "text-center",
            render: function (data) {
                return data ? data : "-";
            },
          },
          {
            data: "materialName",
            className: "text-center",
            render: function (data) {
              return data ? data : "-";
            },
          },
          {
            data: "quantity",
            className: "text-center",
            render: function (data) {
                return data !== null && data !== undefined ? Number(data).toLocaleString('en-US') : 0;
            },
          },
          {
            data: "unitPrice",
            className: "text-center",
            render: function (data) {
                return data !== null && data !== undefined ? Number(data).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) : 0;
            },
          },
          {
            data: null,
            className: "text-center",
            render: function (data, type, row) {
                return Number(row.quantity * row.unitPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 0;
            },
          },
          {
            data: "qiTypeCode",
            className: "text-center",
            render: function (data, type, row) {
              if (data === "JOB_QI_TYPE_PRODUCT_RECEIVE") {
                return "-";
              } else {
                return row.firstName
                  ? `${row.firstName} ${row.lastName}`
                  : row.fullName || "-";
              }
            },
          },
          {
            data: "qiTypeCode",
            className: "text-center",
            render: function (data, type, row) {
              if (data === "JOB_QI_TYPE_PRODUCT_RECEIVE") {
                return row.firstName
                  ? `${row.firstName} ${row.lastName}`
                  : row.fullName || "-";
              } else {
                return row.firstNameConfirm
                  ? `${row.firstNameConfirm} ${row.lastNameConfirm}`
                  : row.fullNameConfirm || "-";
              }
            },
          },
          {
            data: "remark",
            className: "text-center",
            render: function (data) {
              return data ? data : "-";
            },
          },
          {
            data: "qiJobNumber",
            className: "text-center",
            render: function (data) {
              return data ? data : "-";
            },
          },
          {
            data: "refCode",
            className: "text-center",
            render: function (data) {
              return data ? data : "-";
            },
          },
        ],

      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// App/Components/QIJob/ReportDrawback.vue